<script>
import { mapGetters } from 'vuex'
import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'
import omitBy from 'lodash/omitBy'
import isNull from 'lodash/isNull'
import isString from 'lodash/isString'

export default {
  name: 'SchemaOrganization',
  computed: {
    ...mapGetters({
      customerService: 'globalConfig/customerService',
      organization: 'globalConfig/organization',
      social: 'globalConfig/social',
      website: 'globalConfig/website'
    }),

    contactPoint() {
      if (isEmpty(this.customerService.phoneNumber)) {
        return null
      }
      return [
        {
          '@type': 'ContactPoint',
          contactType: this.$t('dictionary.customerService'),
          telephone: this.customerService.phoneNumber
        }
      ]
    },
    socialLinks() {
      return map(this.social, (value) => value.url).filter(isString)
    }
  },
  render() {
    return this.$slots.default
  },
  jsonld() {
    return omitBy(
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: `Sephora ${this.$t('countries.' + this.$i18n.countryCode)}`,
        sameAs: this.socialLinks,
        url: this.website.domain
          ? `https://${this.website.domain}`
          : 'https://www.sephora.sg',
        address: {
          '@type': 'PostalAddress',
          streetAddress: this.organization.streetAddress,
          addressLocality: this.organization.locality,
          addressRegion: this.organization.region,
          postalCode: this.organization.postalCode,
          addressCountry: this.$i18n.countryCode
        },
        logo: this.website.logo,
        description: this.$t('schema.organization.description'),
        email: this.customerService.emailAddress,
        contactPoint: this.contactPoint
      },
      isNull
    )
  }
}
</script>
